export default __webpack_public_path__ + "static/search-1842b2f710598532c2be85dc65345656.gif";